export interface SchoolAttributes {
    label: string
    text: string
    bg: string
    border: string
    description: string
}

export const SPELL_SCHOOLS = [
    "Abjuration",
    "Conjuration",
    "Divination",
    "Enchantment",
    "Evocation",
    "Illusion",
    "Necromancy",
    "Transmutation",
] as const

export type SpellSchool = typeof SPELL_SCHOOLS[number]

export const SCHOOL_COLORS: Record<SpellSchool, SchoolAttributes> = {
    Abjuration: {
        label: "Bannmagie",
        text: 'text-blue-400',
        bg: 'bg-blue-500/20',
        border: 'border-blue-500/50',
        description: 'Schutz- und Bannmagie'
    },
    Conjuration: {
        label: "Beschwörung",
        text: 'text-amber-400',
        bg: 'bg-amber-500/20',
        border: 'border-amber-500/50',
        description: 'Beschwörung und Transport'
    },
    Divination: {
        label: "Erkenntnis",
        text: 'text-indigo-300',
        bg: 'bg-indigo-500/20',
        border: 'border-indigo-500/50',
        description: 'Hellsicht und Wissen'
    },
    Enchantment: {
        label: "Verzauberung",
        text: 'text-pink-400',
        bg: 'bg-pink-500/20',
        border: 'border-pink-500/50',
        description: 'Beeinflussung und Bezauberung'
    },
    Evocation: {
        label: "Hervorrufung",
        text: 'text-red-500',
        bg: 'bg-red-500/20',
        border: 'border-red-500/50',
        description: 'Elementare Energie und Zerstörung'
    },
    Illusion: {
        label: "Illusion",
        text: 'text-purple-400',
        bg: 'bg-purple-500/20',
        border: 'border-purple-500/50',
        description: 'Täuschung und Trugbilder'
    },
    Necromancy: {
        label: "Nekromantie",
        text: 'text-slate-400',
        bg: 'bg-slate-900/60',
        border: 'border-slate-600/50',
        description: 'Tod und Lebenskraft'
    },
    Transmutation: {
        label: "Verwandlung",
        text: 'text-orange-400',
        bg: 'bg-orange-500/20',
        border: 'border-orange-500/50',
        description: 'Veränderung von Materie'
    }
};

export const getSchoolAttributes = (spell: {school?: SpellSchool}): SchoolAttributes => {
    return spell.school ? SCHOOL_COLORS[spell.school] : SCHOOL_COLORS.Abjuration;
};

export function isSpellSchool(value: string): value is SpellSchool {
    return (SPELL_SCHOOLS as readonly string[]).includes(value)
}

export function toSpellSchool(value: string): SpellSchool {
    if (isSpellSchool(value)) return value
    const school = SPELL_SCHOOLS.find(candidate => SCHOOL_COLORS[candidate].label === value)
    if (!school) throw new Error(`Unbekannte Zauberschule: ${value}`)
    return school
}
